import React from 'react';
import PropTypes from 'prop-types';

export default function OfferHandler(props) {
  let { organizationId, offerOrganizationId, value , className,classNameSelf} = props;
  return (    
    <span className={organizationId!=offerOrganizationId?className:classNameSelf}>
      {value}      
    </span>
  );
}
OfferHandler.propTypes = {
  organizationId: PropTypes.string,
  offerOrganizationId: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,  
};
OfferHandler.defaultProps = {
  organizationId: 0,
  offerOrganizationId: 0,
  value: '',
  className:''
};
